import React from 'react';
import PropertyWizard from './PropertyWizard/PropertyWizard';

function CreateFirstProperty() {
  return <PropertyWizard />;
}

export default CreateFirstProperty;
